// extracted by mini-css-extract-plugin
module.exports = {"captchaField":"captchaField[Frida]3xMKfgeh"};